import { GitProvider } from '../consts/git';
import Azure from './Azure';
import AzurePlaceholder from './AzurePlaceholder';
import Bitbucket from './Bitbucket';
import Gerrit from './Gerrit';
import Github from './Github';
import Gitlab from './Gitlab';
import { GitPlaceholder } from './GitPlaceholder';
import { LogoProps } from './types';

/**
 * Map of Git providers to their corresponding logo components.
 * Deliberately free of auth imports: ubiquitous UI (`ProviderLogo`, table cells) renders
 * these, and importing them from `utils/git` would drag axios and the OAuth login-URL
 * machinery into every chunk that shows a provider mark.
 */
export const IconsMap: Record<GitProvider, React.FC<LogoProps>> = {
  github: Github,
  gitlab: Gitlab,
  bitbucket: Bitbucket,
  bitbucket_datacenter: Bitbucket,
  azure: Azure,
  gerrit: Gerrit,
};

/**
 * Map of Git providers to their corresponding placeholder logo components, used when avatar URL is not available
 */
export const IconsPlaceholderMap: Record<GitProvider, React.FC<LogoProps>> = {
  github: GitPlaceholder,
  gitlab: Gitlab,
  bitbucket: Bitbucket,
  bitbucket_datacenter: Bitbucket,
  azure: AzurePlaceholder,
  gerrit: Gerrit,
};
